import VueI18n from 'vue-i18n'
import Vue from 'vue'
import store from '../store'
Vue.use(VueI18n);

const i18n = new VueI18n({
    locale: store.state.common.lang // 语言标识
});

function setI18nLanguage(lang) { 
    if (i18n.locale != lang) {
        i18n.locale = lang;
    }
    return lang;
}

//载入其他语言，这个可能需要变更，非英语语言，需要使用远程文件存储
export function loadLanguageAsync(l) {
    let cu = store.state.common.country;
    let lang = l;
    let langkey = `${lang}-${cu}`;
    if (!store.state.temp.loadedLanguages.includes(langkey)) {
        return import(`@/assets/lang/${langkey}`).then(msgs => {
            i18n.setLocaleMessage(langkey, msgs)
            store.commit('temp/pushLanguage', langkey)
            return setI18nLanguage(langkey)
        })
    } else {
        setI18nLanguage(langkey);
    }
    return Promise.resolve(langkey)
}

//载入语言包，如果存在则不会重新载入
export function reloadLanguageAsync() {
    let cu = store.state.common.country;
    let lang = store.state.common.lang;
    let langkey = `${lang}-${cu}`;
  
    if (!store.state.temp.loadedLanguages.includes(langkey)) {
        return import(`@/assets/lang/${langkey}`).then(msgs => {
            i18n.setLocaleMessage(langkey, msgs);
            store.commit('temp/pushLanguage', langkey)
            return setI18nLanguage(langkey);
        })
    } else {
        setI18nLanguage(langkey);
    }
    return Promise.resolve(langkey)
}

export default i18n;


// WEBPACK FOOTER //
// ./src/utils/i18n.js